import React, { useEffect, useState } from 'react';
import * as Styled from './ClientLoyaltyPage.styles';

import { getFromLocalStorage } from '../../global/helpers';
import { CurrentReceiptData } from '../LoyaltyPage/types';
import ClientLoyaltyInfo from './components/ClientLoyaltyInfo';
import ClientLoyaltyTable from './components/ClientLoyaltyTable';

const ClientLoyaltyPage = ({
  updClientLoyaltyImg,
}: {
  updClientLoyaltyImg?: boolean;
}) => {
  const [chosenReceipt, setChosenReceipt] = useState<CurrentReceiptData | null>(
    null
  );

  useEffect(() => {
    setChosenReceipt(getFromLocalStorage('chosenReceipt'));
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const chosenReceipt = getFromLocalStorage('chosenReceipt');
      setChosenReceipt(chosenReceipt ?? null);
    }, 3000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Styled.ClientLoyaltyPageContainer>
      {/* {chosenReceipt ? (
        <ClientLoyaltyTable chosenReceipt={chosenReceipt} />
      ) : ( */}
      <ClientLoyaltyInfo updClientLoyaltyImg={updClientLoyaltyImg} />
      {/* )} */}
    </Styled.ClientLoyaltyPageContainer>
  );
};

export default ClientLoyaltyPage;
